export const PESANTREN_DEMO_TEXT = `فلما وصلت الروح إلى جوفه اشتهى الطعام، ثم انتشرت الروح في كل جسده فصار لحما ودما وعروقا وعصبا، ثم كساه الله تعالى لباسا من ظفر، يزداد كل يوم حسنا وجمالا.`;

export const DEMO_PESANTREN_ANALYSIS = {
  note: "I'rab ala pesantren untuk kisah penciptaan Nabi Adam (ringkas & hemat token).",
  chunks: [
    {
      title: "Bagian 1",
      arabic: "فَلَمَّا وَصَلَتِ الرُّوحُ إِلَى جَوْفِهِ",
      translation: "Ketika ruh telah sampai ke dalam perutnya.",
      irab: [
        { p: "فَ", r: "حرف عطف" },
        { p: "لَمَّا", r: "ظرف زمان" },
        { p: "وَصَلَتْ", r: "فعل ماضٍ" },
        { p: "الرُّوحُ", r: "فاعل" },
        { p: "إِلَى", r: "حرف جر" },
        { p: "جَوْفِهِ", r: "اسم مجرور وهو مضاف، والهاء مضاف إليه" }
      ]
    },
    {
      title: "Bagian 2",
      arabic: "اشْتَهَى الطَّعَامَ",
      translation: "Ia menginginkan makanan.",
      irab: [
        { p: "اشْتَهَى", r: "فعل ماضٍ" },
        { p: "الفاعل", r: "ضمير مستتر (آدم)" },
        { p: "الطَّعَامَ", r: "مفعول به" }
      ]
    },
    {
      title: "Bagian 3",
      arabic: "ثُمَّ انْتَشَرَتِ الرُّوحُ فِي كُلِّ جَسَدِهِ",
      translation: "Kemudian ruh menyebar ke seluruh tubuhnya.",
      irab: [
        { p: "ثُمَّ", r: "حرف عطف" },
        { p: "انْتَشَرَتْ", r: "فعل ماضٍ" },
        { p: "الرُّوحُ", r: "فاعل" },
        { p: "فِي", r: "حرف جر" },
        { p: "كُلِّ", r: "اسم مجرور وهو مضاف" },
        { p: "جَسَدِهِ", r: "مضاف إليه" }
      ]
    },
    {
      title: "Bagian 4",
      arabic: "فَصَارَ لَحْمًا وَدَمًا وَعُرُوقًا وَعَصَبًا",
      translation: "Maka jadilah ia daging, darah, urat-urat, dan saraf.",
      irab: [
        { p: "فَ", r: "حرف عطف" },
        { p: "صَارَ", r: "فعل ناقص" },
        { p: "اسمه", r: "ضمير مستتر (آدم)" },
        { p: "لَحْمًا", r: "خبر صار" },
        { p: "وَدَمًا", r: "معطوف" },
        { p: "وَعُرُوقًا", r: "معطوف" },
        { p: "وَعَصَبًا", r: "معطوف" }
      ]
    }
  ]
};